"use client";
import React, { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";

const OverviewMfGraph = ({ basicGraph, longGraph, loading }) => {
  const [basicDataPoints, setBasicDataPoints] = useState([]);
  const [selection, setSelection] = useState("one_month");

  const options = {
    chart: {
      id: "area-datetime",
      type: "area",
      height: 350,
      zoom: {
        autoScaleYaxis: true,
      },
      toolbar: {
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      colors: ["#47B971"],
    },
    markers: {
      size: 0,
      style: "hollow",
      colors: ["#47B971"],
      hover: {
        size: 6,
        colors: ["#47B971"],
      },
    },
    plotOptions: {
      area: {
        colors: ["#47B971"],
      },
      dataLabels: {
        enabled: false,
      },
    },
    xaxis: {
      type: "datetime",
      min: new Date(basicDataPoints[0]?.data[0][0]).getTime(),
      tickAmount: 6,
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return `₹${value.toFixed(2)}`;
        },
      },
    },
    tooltip: {
      color: "#47B971",
      x: {
        format: "dd MMM yyyy",
      },
      y: {
        formatter: function (value) {
          return `₹${value.toFixed(2)}`;
        },
        title: {
          formatter: function (seriesName) {
            return "Value";
          },
        },
        color: "#47B971",
      },
      marker: {
        fillColors: ["#47B971"],
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 100],
        colorStops: [
          { offset: 0, color: "#47B971", opacity: 0.7 },
          { offset: 100, color: "#47B971", opacity: 0.1 },
        ],
      },
    },
  };

  const updateData = (timeline) => {
    setSelection(timeline);
    let arrayOfArrays;
    let arrayBasic;

    switch (timeline) {
      case "one_month":
        arrayOfArrays = Object.entries(basicGraph?.monthly);
        arrayBasic = [{ data: arrayOfArrays }];
        setBasicDataPoints(arrayBasic);
        ApexCharts.exec(
          "area-datetime",
          "zoomX",
          new Date(arrayBasic[0].data[0][0]).getTime(),
          new Date(
            arrayBasic[0].data[arrayBasic[0].data.length - 1][0]
          ).getTime()
        );
        break;
      case "six_months":
        arrayOfArrays = Object.entries(basicGraph?.six_months);
        arrayBasic = [{ data: arrayOfArrays }];
        setBasicDataPoints(arrayBasic);
        ApexCharts.exec(
          "area-datetime",
          "zoomX",
          new Date(arrayBasic[0].data[0][0]).getTime(),
          new Date(
            arrayBasic[0].data[arrayBasic[0].data.length - 1][0]
          ).getTime()
        );
        break;
      case "one_year":
        arrayOfArrays = Object.entries(basicGraph?.year);
        arrayBasic = [{ data: arrayOfArrays }];
        setBasicDataPoints(arrayBasic);
        ApexCharts.exec(
          "area-datetime",
          "zoomX",
          new Date(arrayBasic[0].data[0][0]).getTime(),
          new Date(
            arrayBasic[0].data[arrayBasic[0].data.length - 1][0]
          ).getTime()
        );
        break;
      case "three_year":
        arrayOfArrays = Object.entries(longGraph?.three_year);
        arrayBasic = [{ data: arrayOfArrays }];
        setBasicDataPoints(arrayBasic);
        ApexCharts.exec(
          "area-datetime",
          "zoomX",
          new Date(arrayBasic[0].data[0][0]).getTime(),
          new Date(
            arrayBasic[0].data[arrayBasic[0].data.length - 1][0]
          ).getTime()
        );
        break;
      case "five_year":
        arrayOfArrays = Object.entries(longGraph?.five_year);
        arrayBasic = [{ data: arrayOfArrays }];
        setBasicDataPoints(arrayBasic);
        ApexCharts.exec(
          "area-datetime",
          "zoomX",
          new Date(arrayBasic[0].data[0][0]).getTime(),
          new Date(
            arrayBasic[0].data[arrayBasic[0].data.length - 1][0]
          ).getTime()
        );
        break;
      default:
    }
  };

  useEffect(() => {
    if (basicGraph && basicGraph?.monthly) {
      setSelection("one_month");
      const arrayOfArrays = Object.entries(basicGraph?.monthly);
      let arrayBasic = [{ data: arrayOfArrays }];
      setBasicDataPoints(arrayBasic);
    }
  }, [basicGraph]);

  return (
    <div className="mx-4">
      <div id="chart">
        <div id="chart-timeline">
          <Chart
            options={options}
            series={basicDataPoints && basicDataPoints}
            type="area"
            height={350}
          />
        </div>
        <div className="flex flex-row justify-center items-center gap-14 text-xs font-medium mt-6">
          <button
            id="one_month"
            onClick={() => updateData("one_month")}
            className={
              selection === "one_month"
                ? "active bg-[#A0FF77] py-0.5 px-1 rounded text-[#333333]"
                : "text-[#8B8B8B]"
            }
          >
            1M
          </button>
          <button
            id="six_months"
            onClick={() => updateData("six_months")}
            className={
              selection === "six_months"
                ? "active bg-[#A0FF77] py-0.5 px-1 rounded text-[#333333]"
                : "text-[#8B8B8B]"
            }
          >
            6M
          </button>
          <button
            id="one_year"
            onClick={() => updateData("one_year")}
            className={
              selection === "one_year"
                ? "active bg-[#A0FF77] py-0.5 px-1 rounded text-[#333333]"
                : "text-[#8B8B8B]"
            }
          >
            1Y
          </button>
          <button
            id="ytd"
            onClick={() => updateData("three_year")}
            className={
              selection === "three_year"
                ? "active bg-[#A0FF77] py-0.5 px-1 rounded text-[#333333]"
                : "text-[#8B8B8B]"
            }
          >
            3Y
          </button>
          <button
            id="all"
            onClick={() => updateData("five_year")}
            className={
              selection === "five_year"
                ? "active bg-[#A0FF77] py-0.5 px-1 rounded text-[#333333]"
                : "text-[#8B8B8B]"
            }
          >
            5Y
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverviewMfGraph;
